import { render, staticRenderFns } from "./prize.vue?vue&type=template&id=e2e99fcc&"
import script from "./prize.vue?vue&type=script&lang=js&"
export * from "./prize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports